/**
 * Multi-file upload dropzone, replacing the former UIkit.upload widget.
 * Markup contract (see MediaController_upload.ss):
 *   [data-behaviour="dropzone"] with data-url (POST target) and data-redirect
 *   <input type="file" multiple> inside the dropzone (optional, for click-select)
 *   #js-progressbar as <progress> element
 * Files are POSTed sequentially as form field "File" — same server contract
 * as before (MediaController::doupload answers "OK" per file).
 */
export function initDropzone() {
    const dropZone = document.querySelector('[data-behaviour="dropzone"]');
    if (!dropZone) {
        return;
    }

    const url = dropZone.getAttribute('data-url');
    const bar = document.getElementById('js-progressbar');
    const fileInput = dropZone.querySelector('input[type="file"]');

    function uploadFile(file) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', url);
            xhr.upload.addEventListener('progress', (e) => {
                if (bar && e.lengthComputable) {
                    bar.max = e.total;
                    bar.value = e.loaded;
                }
            });
            xhr.addEventListener('load', () => {
                xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(xhr.statusText));
            });
            xhr.addEventListener('error', () => reject(new Error('Upload failed')));

            const formData = new FormData();
            formData.append('File', file);
            xhr.send(formData);
        });
    }

    async function uploadAll(files) {
        if (!files.length) {
            return;
        }
        if (bar) {
            bar.removeAttribute('hidden');
        }
        dropZone.classList.add('opacity-50');
        try {
            for (const file of files) {
                await uploadFile(file);
            }
        } catch (err) {
            console.error('dropzone:', err);
            alert('Fehler beim Hochladen: ' + err.message);
            dropZone.classList.remove('opacity-50');
            return;
        }
        setTimeout(() => {
            if (bar) {
                bar.setAttribute('hidden', 'hidden');
            }
        }, 1000);

        const redirectUrl = dropZone.getAttribute('data-redirect');
        if (redirectUrl) {
            window.location.href = redirectUrl;
        }
    }

    ['dragenter', 'dragover'].forEach((type) => {
        dropZone.addEventListener(type, (e) => {
            e.preventDefault();
            dropZone.classList.add('border-primary');
        });
    });
    ['dragleave', 'drop'].forEach((type) => {
        dropZone.addEventListener(type, (e) => {
            e.preventDefault();
            dropZone.classList.remove('border-primary');
        });
    });
    dropZone.addEventListener('drop', (e) => {
        uploadAll([...e.dataTransfer.files]);
    });

    if (fileInput) {
        fileInput.addEventListener('change', () => {
            uploadAll([...fileInput.files]);
        });
    }
}
